import FindAClinician from "./FindAClinician"

export default FindAClinician
